import { ACTION_TYPE } from '../../util/GlobalData'
const ProductState = {
    products: [],
    loading: Boolean
}


export const ProductReducer = (state = ProductState, { type, payload }) => {
    switch (type) {
        case ACTION_TYPE.LOADING:
            return { ...state, loading: payload }
        case ACTION_TYPE.PRODUCTS:
            return { ...state, products: payload, }
        default:
            return state
    }
}
